// Custom Loading Image Overlay Management
(function() {
  let loadingOverlay = null;
  let hasCustomImage = false;

  // Initialize custom loading image overlay
  function initCustomLoadingImage() {
    const loadingImageUrl = window.themeVariables?.settings?.loadingAnimationImage;
    
    if (loadingImageUrl && loadingImageUrl.trim() !== '') {
      hasCustomImage = true;
      document.body.classList.add('has-custom-loading-image');
      
      // Create overlay element if it doesn't exist
      if (!loadingOverlay) {
        loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'custom-loading-overlay';
        const img = document.createElement('img');
        img.className = 'custom-loading-overlay__image';
        img.src = loadingImageUrl;
        img.alt = 'Loading...';
        loadingOverlay.appendChild(img);
        document.body.appendChild(loadingOverlay);
      }
    } else {
      hasCustomImage = false;
      document.body.classList.remove('has-custom-loading-image');
    }
  }

  // Show custom loading overlay
  function showCustomLoadingOverlay() {
    if (hasCustomImage && loadingOverlay) {
      loadingOverlay.classList.add('active');
      document.body.style.pointerEvents = 'none';
    }
  }

  // Hide custom loading overlay
  function hideCustomLoadingOverlay() {
    if (loadingOverlay) {
      loadingOverlay.classList.remove('active');
      document.body.style.pointerEvents = '';
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomLoadingImage);
  } else {
    initCustomLoadingImage();
  }

  // Expose functions globally
  window.showCustomLoadingOverlay = showCustomLoadingOverlay;
  window.hideCustomLoadingOverlay = hideCustomLoadingOverlay;
  window.hasCustomLoadingImage = function() { return hasCustomImage; };
})();

// // cart page block

// if (location.pathname === "/cart" && !location.search) {
//   window.location.href = "/?return_link=cart";
// }

// // Open cart drawer when redirected with ?return_link=cart
// if (new URLSearchParams(location.search).has("return_link")) {
//   const cartDrawerObserver = new MutationObserver(() => {
//     let cartDrawer = document.querySelector("cart-drawer");
//     if (cartDrawer) {
//       cartDrawer.show();
//       cartDrawerObserver.disconnect(); // Stop observing after cart opens
//     }
//   });
//   cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

//   // Remove return_link=cart from the URL
//   const newUrl = location.href.replace(/[?&]return_link=cart/g, "");
//   history.replaceState({}, document.title, newUrl);
// }

// // Handle browser back button to close cart
// window.addEventListener("popstate", function (event) {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer && !location.search.includes("cartOpen=true")) {
//     cartDrawer.close();
//   } else if (event.state?.cart === "show" && cartDrawer) {
//     cartDrawer.show();
//   }
// });

// // Ensure cartOpen=true is removed from URL if cart is closed
// document.addEventListener("DOMContentLoaded", () => {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer && !cartDrawer.classList.contains("active")) {
//     const newUrl = location.href.replace(/[?&]cartOpen=true/g, "");
//     history.replaceState({}, document.title, newUrl);
//   }
// });

// // Open cart and push cartOpen=true into history
// function openCart() {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer) {
//     cartDrawer.show();
//     history.pushState({ cart: "show" }, "", "?cartOpen=true");
//   }
// }

// judgeme js
const ratingProductCard = document.querySelector(".rating-pdp-card");
const judgemeProductReviews = document.getElementById(
  "judgeme_product_reviews"
);
ratingProductCard?.addEventListener("click", function () {
  judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
});

class RoundRating extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const value = parseFloat(this.textContent.trim());
    const roundedValue = Math.round(value * 10) / 10;
    this.textContent = roundedValue.toFixed(1);
  }
}

customElements.define("round-rating", RoundRating);

//round number

class RandomNumber extends HTMLElement {
  constructor() {
    super();
    // Include current URL path in storage key
    this.storageKey = `random-number-values-${window.location.pathname}`;

    // Initialize storage for this page if needed
    if (!sessionStorage.getItem(this.storageKey)) {
      sessionStorage.setItem(this.storageKey, JSON.stringify({}));
    }
  }

  generateUniqueId() {
    const allRandomNumbers = document.getElementsByTagName("random-number");
    for (let i = 0; i < allRandomNumbers.length; i++) {
      if (allRandomNumbers[i] === this) {
        return `random-number-${window.location.pathname}-${i}`;
      }
    }
    return `random-number-${window.location.pathname}-${Date.now()}`;
  }

  connectedCallback() {
    const min = parseInt(this.dataset.min) || 0;
    const max = parseInt(this.dataset.max) || 100;

    // Use element's ID or generate a stable one
    const elementId = this.getAttribute("id") || this.generateUniqueId();
    this.setAttribute("id", elementId);

    let storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));

    // Generate new value only if it doesn't exist for this page
    if (!storedValues[elementId]) {
      const newValue = Math.floor(Math.random() * (max - min + 1)) + min;
      storedValues[elementId] = newValue;
      sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
    }

    this.textContent = storedValues[elementId];
  }

  disconnectedCallback() {
    const elementId = this.getAttribute("id");
    const storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));
    if (storedValues && elementId) {
      delete storedValues[elementId];
      // Only remove from storage if no more values exist for this page
      if (Object.keys(storedValues).length === 0) {
        sessionStorage.removeItem(this.storageKey);
      } else {
        sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
      }
    }
  }
}
// Register the custom element
customElements.define("random-number", RandomNumber);

// cart-change-handler.js - OPTIMIZED

document.addEventListener("cart:change", debounce(async (event) => {
  // Capture event data inside debounced function to prevent stale data
  const cartData = event.detail.cart;
  const baseEvent = event.detail.baseEvent;

  // Prevent infinite loops - don't process if this is from auto-removal or sync
  if (baseEvent === "gift-items:auto-remove") {
    return;
  }

  // First handle the case of removing add-ons when main product is gone
  const mainProducts = cartData.items.filter(
    (item) => !item.properties?._main_product
  );
  const addOns = cartData.items.filter(
    (item) => item.properties?._main_product
  );

  // If there are add-ons but no main products, remove ALL add-ons
  if (addOns.length > 0 && mainProducts.length === 0) {
    await forceRemoveAllAddons(addOns);
    return; // Exit early after handling this case
  }

  // Check if any add-ons have a main product that no longer exists
  // IMPORTANT: Skip this check immediately after variant:add events to prevent
  // removing add-ons that were just added along with their main product.
  // The addProductsToCart function adds both main product and add-ons together,
  // so we need to skip orphaned checks on variant:add to avoid race conditions.
  // Subsequent cart changes (like item:remove, line-item:change) will handle
  // truly orphaned add-ons.
  if (addOns.length > 0 && mainProducts.length > 0 && baseEvent !== "variant:add") {
    const mainProductHandles = new Set(mainProducts.map(main => main.handle));
    const orphanedAddons = addOns.filter((addon) => {
      return !mainProductHandles.has(addon.properties._main_product);
    });

    if (orphanedAddons.length > 0) {
      await forceRemoveAllAddons(orphanedAddons);
      return; // Exit early after handling this case
    }
  }

  // Handle changes to the main product quantity
  // Skip quantity sync if this event is from a sync operation itself
  if (
    baseEvent !== "addon-quantity:sync" &&
    (baseEvent === "line-item:change" ||
    baseEvent === "variant:add" ||
    baseEvent === "item:remove")
  ) {
    // Group addons by main product handle for efficient lookup
    const addonsByMainProduct = new Map();
    addOns.forEach(addon => {
      const mainHandle = addon.properties._main_product;
      if (!addonsByMainProduct.has(mainHandle)) {
        addonsByMainProduct.set(mainHandle, []);
      }
      addonsByMainProduct.get(mainHandle).push(addon);
    });
    
    // For each main product
    for (const mainProduct of mainProducts) {
      const relatedAddons = addonsByMainProduct.get(mainProduct.handle) || [];
      if (relatedAddons.length === 0) continue;

      // If main product quantity is 0, remove all its add-ons
      if (mainProduct.quantity === 0) {
        await forceRemoveAllAddons(relatedAddons);
        continue;
      }

      // For ready-to-wear, blouse customization, and remove-cups items, sync quantities
      // Gift products are NOT synced and remain independent
      const syncableAddons = relatedAddons.filter((addon) => {
        const title = (addon.product_title || '').toLowerCase();
        const variantTitle = (addon.variant_title || '').toLowerCase();
        const handle = addon.handle || '';
        
        return handle === "make-this-saree-ready-to-wear-copy" ||
               handle === "customise-blouse" ||
               handle === "remove-cups" ||
               title.includes("ready-to-wear") ||
               title.includes("pre-drape") ||
               title.includes("blouse customization") ||
               title.includes("customise blouse") ||
               title.includes("remove cups") ||
               variantTitle.includes("ready-to-wear");
      });

      if (syncableAddons.length > 0) {
        // Check if any addon needs its quantity updated
        const needsSync = syncableAddons.some(
          (addon) => addon.quantity !== mainProduct.quantity
        );

        if (needsSync) {
          await syncAddonQuantities(syncableAddons, mainProduct.quantity);
        }
      }
    }
  }

  if (baseEvent === "item:add" || baseEvent === "variant:add") {
    // Check confetti type from theme settings
    const confettiType = window.themeVariables?.settings?.confettiType || 'none';
    
    if (confettiType !== 'none' && typeof window.triggerConfetti === 'function') {
      window.triggerConfetti({ type: confettiType });
    }
    
    // Show toast notification on add to cart (if enabled)
    const toastEnabled = window.themeVariables?.settings?.enableToastNotification !== false;
    if (toastEnabled) {
      showAddToCartToast();
    }
  }

  // Check for gift-wrapping items - should run after all other operations
  await checkAndRemoveGiftWrappingItems(cartData);

  // Update cart drawer freebie UI and clean up any legacy freebie cart line items
  await processFreebies(cartData);
  updateFreebieLineItemsUI(cartData);

  // Reinitialize carousels after cart changes
  // Use a small timeout to ensure DOM updates from cart operations are complete
  setTimeout(() => {
    if (window.CustomCarousel && typeof CustomCarousel.reinitializeAll === 'function') {
      CustomCarousel.reinitializeAll();
    }
  }, 200);
  
}, 150)); // Debounce for 150ms to reduce frequency

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Build updates object with all quantities set to 0
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = 0;
    });

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) throw new Error("Failed to update cart");

    const updatedCartContent = await response.json();

    // Dispatch cart change event to update the UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "item:remove",
          cart: updatedCartContent,
        },
      })
    );

    // Update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error removing add-ons:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Update all addons to the new quantity
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = newQuantity;
    });

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update cart");
    }

    const updatedCartContent = await response.json();

    // Dispatch a special event to prevent re-processing by the sync logic
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "addon-quantity:sync",
          cart: updatedCartContent,
        },
      })
    );

    // Force update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error syncing addon quantities:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Size Chart Toggle in inches and cms
if (document.querySelector(".toggle-tab-inches-cm")) {
  window.handleSizeToggle();
}

// Tab functionality for size chart (converted from jQuery)
window.handleSizeChartTabs = function () {
  const tabs = document.querySelectorAll('ul.tabs li');
  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      const tabId = this.getAttribute('data-tab');
      
      // Remove current class from all tabs
      tabs.forEach((t) => t.classList.remove('current'));
      // Remove current class from all tab contents
      document.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.remove('current');
      });
      
      // Add current class to clicked tab
      this.classList.add('current');
      // Add current class to corresponding tab content
      const tabContent = document.getElementById(tabId);
      if (tabContent) {
        tabContent.classList.add('current');
      }
    });
  });
};

// Initialize size chart tabs when data-tab="tab-2" is found
if (document.querySelector('ul.tabs li[data-tab="tab-2"]')) {
  console.log('page.size-chart loaded =>>>>>');
  window.handleSizeChartTabs();
}

// typewriter component
class TypewriterComponent extends HTMLElement {
  constructor() {
    super();
    this.texts = Array.from(this.querySelectorAll("p")).map(
      (message) => message.innerHTML
    );
    this.currentTextIndex = 0;
    this.currentCharIndex = 0;
    this.isDeleting = false;
    this.typeSpeed = 100; // Adjust typing speed (in milliseconds)
    this.deleteSpeed = 50; // Adjust deleting speed (in milliseconds)
    this.pauseBetweenTexts = 2000; // Pause between texts (in milliseconds)
    this.type();
  }

  type() {
    const currentText = this.texts[this.currentTextIndex];
    const displayText = this.isDeleting
      ? currentText.substring(0, this.currentCharIndex - 1)
      : currentText.substring(0, this.currentCharIndex + 1);

    this.innerHTML = displayText;

    if (!this.isDeleting) {
      this.currentCharIndex++;
      if (this.currentCharIndex === currentText.length) {
        this.isDeleting = true;
        setTimeout(() => this.type(), this.pauseBetweenTexts);
      } else {
        setTimeout(() => this.type(), this.typeSpeed);
      }
    } else {
      this.currentCharIndex--;
      if (this.currentCharIndex === 0) {
        this.isDeleting = false;
        this.currentTextIndex = (this.currentTextIndex + 1) % this.texts.length;
        setTimeout(() => this.type(), this.typeSpeed);
      } else {
        setTimeout(() => this.type(), this.deleteSpeed);
      }
    }
  }
}

customElements.define("typewriter-component", TypewriterComponent);


// Add this function to check and remove gift wrap and bag items when they're alone in cart
async function checkAndRemoveGiftWrappingItems(cartData) {
  // Check if cart has items
  if (!cartData || !cartData.items || cartData.items.length === 0) return;

  // Filter all gift wrap and bag items (items with _is_gift_wrap or _is_bag property)
  const giftWrapAndBagItems = cartData.items.filter(
    (item) => item.properties?._is_gift_wrap === 'Yes' || item.properties?._is_bag === 'Yes'
  );

  // Get all main products (items that are not add-ons, not gift wraps, not bags)
  const regularItems = cartData.items.filter(
    (item) => !item.properties?._main_product && 
              item.properties?._is_gift_wrap !== 'Yes' && 
              item.properties?._is_bag !== 'Yes'
  );

  // If there are gift/bag items but NO regular items (only gifts/bags in cart), remove them
  if (giftWrapAndBagItems.length > 0 && regularItems.length === 0) {
    
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // Prepare updates to set gift wrap and bag items quantities to 0
      const updates = giftWrapAndBagItems.reduce((acc, item) => {
        acc[item.key] = 0;
        return acc;
      }, {});

      // Update cart to remove gift wrap and bag items
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error("Failed to update cart");
      
      const updatedCartContent = await response.json();

      // Dispatch cart change event to update the UI
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "gift-items:auto-remove",
            cart: updatedCartContent,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    } catch (error) {
      console.error("Error removing gift wrap and bag items:", error);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      if (window.themeVariables?.settings.showErrorMessage) {
        alert(error.message);
      }
    }
  }
}

// section scroller - unified for all pages: top 50% scrolls to bottom, bottom 50% scrolls to top
class SectionScroller extends HTMLElement {
  constructor() {
    super();
    this.hasBeenRevealed = false;
    this.addEventListener("click", this.handleClick.bind(this));
    this.scrollHandler = this.handleScroll.bind(this);
  }

  connectedCallback() {
    window.addEventListener("scroll", this.scrollHandler, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.scrollHandler);
  }

  handleClick() {
    if (this.isInTopHalf) {
      window.scrollTo({
        top: document.documentElement.scrollHeight - window.innerHeight,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const maxScroll = scrollHeight - clientHeight;

    // Top half: 0 to 50% of scrollable area
    this.isInTopHalf = maxScroll <= 0 || scrollTop < maxScroll * 0.5;
    this.updateArrowDirection();
  }

  updateArrowDirection() {
    // Hidden until first scroll past 50%; then always visible
    if (!this.hasBeenRevealed && !this.isInTopHalf) {
      this.hasBeenRevealed = true;
    }
    if (!this.hasBeenRevealed) {
      this.style.opacity = "0";
      this.style.pointerEvents = "none";
      return;
    }
    this.style.opacity = "1";
    this.style.pointerEvents = "auto";
    // Top half: arrow down (180deg), click scrolls to bottom. Bottom half: arrow up (0deg), click scrolls to top
    this.style.transform = this.isInTopHalf ? "scale(1) rotateZ(180deg)" : "scale(1) rotateZ(0deg)";
  }
}

customElements.define("section-scroller", SectionScroller);

class BottomCart extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateHandler = this.handleCartUpdate.bind(this);
    this.bundleSectionsHandler = this.handleBundleSections.bind(this);
    this.refreshCartHandler = this.handleRefreshCart.bind(this);
  }

  connectedCallback() {
    // Add event listeners
    document.addEventListener("cart:change", this.cartUpdateHandler);
    document.addEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.addEventListener("cart:refresh", this.refreshCartHandler);
  }

  disconnectedCallback() {
    // Remove event listeners
    document.removeEventListener("cart:change", this.cartUpdateHandler);
    document.removeEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.removeEventListener("cart:refresh", this.refreshCartHandler);
  }

  handleBundleSections(event) {
    // Add this section's ID to the sections that should be updated
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );
    event.detail.sections.push(sectionId);
  }

  handleCartUpdate(event) {
    const cartData = event.detail.cart;
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Get the updated HTML for this section
    const sectionHtml = cartData.sections[sectionId];

    if (sectionHtml) {
      // Parse and update the section content
      const domElement = new DOMParser().parseFromString(
        sectionHtml,
        "text/html"
      );
      const newContent = domElement.querySelector("bottom-cart").innerHTML;
      this.innerHTML = newContent;
    }
  }

  async handleRefreshCart() {
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Fetch the latest cart section HTML
    const response = await fetch(
      `${window.Shopify.routes.root}?section_id=${sectionId}`
    );
    const html = await response.text();

    // Parse and update the section content
    const domElement = new DOMParser().parseFromString(html, "text/html");
    const newContent = domElement.querySelector("bottom-cart").innerHTML;
    this.innerHTML = newContent;
  }
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get("bottom-cart")) {
  customElements.define("bottom-cart", BottomCart);
}

// Toast notification for add to cart
let toastTimeout = null;

function showAddToCartToast() {
  // Remove any existing toast
  const existingToast = document.querySelector('.atc-toast');
  if (existingToast) {
    existingToast.remove();
  }
  
  // Clear any pending timeout
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }

  // Get toast settings
  const settings = window.themeVariables?.settings || {};
  const backgroundImage = settings.toastBackgroundImage || '';
  const hasBackgroundImage = backgroundImage && backgroundImage !== null && backgroundImage.trim() !== '';

  // Create toast element
  const toast = document.createElement('div');
  toast.className = 'atc-toast';
  
  // Apply background image styles if available (using recommended dimensions: 400x100px)
  if (hasBackgroundImage) {
    toast.style.backgroundImage = `url(${backgroundImage})`;
    toast.style.backgroundSize = 'cover';
    toast.style.backgroundPosition = 'center';
    toast.style.backgroundRepeat = 'no-repeat';
    toast.style.width = '400px';
    toast.style.height = '100px';
  }

  // Build toast content - only show text if no background image
  const messageContent = hasBackgroundImage 
    ? '' 
    : `
      <div class="atc-toast__message">
        <svg class="atc-toast__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6667 5.83333L7.50004 15L3.33337 10.8333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Added to cart!</span>
      </div>
    `;

  toast.innerHTML = `
    <div class="atc-toast__content">
      ${messageContent}
      <button class="atc-toast__close" aria-label="Close notification" type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="atc-toast__progress">
      <div class="atc-toast__progress-bar"></div>
    </div>
  `;

  // Add to body
  document.body.appendChild(toast);

  // Trigger animation
  requestAnimationFrame(() => {
    toast.classList.add('atc-toast--show');
  });

  // Close button handler
  const closeBtn = toast.querySelector('.atc-toast__close');
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    closeToast(toast);
  });

  // Click on toast to open cart
  toast.addEventListener('click', (e) => {
    // Don't open cart if clicking the close button
    if (e.target.closest('.atc-toast__close')) {
      return;
    }
    openCartDrawer();
    closeToast(toast);
  });

  // Auto-close after 3 seconds
  toastTimeout = setTimeout(() => {
    closeToast(toast);
    toastTimeout = null;
  }, 3000);
}

function closeToast(toast) {
  if (!toast) return;
  
  // Clear timeout if toast is manually closed
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }
  
  toast.classList.add('atc-toast--hide');
  setTimeout(() => {
    if (toast.parentNode) {
      toast.remove();
    }
  }, 300);
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') {
    cartDrawer.show();
  }
}

// Confetti function for celebrations
window.triggerConfetti = function(options = {}) {
  // Get confetti type from options or default to 'default'
  const confettiType = options.type || 'default';
  
  // Define confetti configurations for different types
  const confettiConfigs = {
    'default': {
      particleCount: 200,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 50,
      colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
    },
    'valentine': {
      particleCount: 250,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 60,
      colors: ['#ffb3d9', '#ff69b4', '#ff1493', '#ff6b9d', '#ffc0cb', '#ff69b4'],
      emojis: ['💖', '❤️', '💕', '💗', '💓', '💝'],
      emojiSize: 50
    },
    'independence': {
      particleCount: 300,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 60,
      colors: ['#FF9933', '#FFFFFF', '#138808'], // Saffron, White, Green
      shapes: ['circle', 'square']
    },
    'festival': {
      particleCount: 250,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 55,
      colors: ['#FFD700', '#FFA500', '#FF6347', '#FF69B4', '#FF1493', '#FFB6C1'],
      emojis: ['🌸', '🌺', '🪔', '🕯️', '🌼', '🌻'],
      emojiSize: 50
    }
  };
  
  // Get base config for the type
  const baseConfig = confettiConfigs[confettiType] || confettiConfigs['default'];
  
  // Merge with passed options (options override base config)
  const confettiOptions = { ...baseConfig, ...options };
  // Remove 'type' from options as it's not a valid confetti parameter
  delete confettiOptions.type;
  
  if (typeof confetti === 'function') {
    confetti(confettiOptions);
  } else {
    // Wait for confetti library to load
    const maxWait = 3000; // 3 seconds max
    const interval = 100; // Check every 100ms
    let waited = 0;
    
    const checkConfetti = setInterval(() => {
      // Increment waited before checking to ensure accurate timing
      waited += interval;
      
      if (typeof confetti === 'function') {
        clearInterval(checkConfetti);
        confetti(confettiOptions);
      } else if (waited >= maxWait) {
        clearInterval(checkConfetti);
        console.log('Confetti library failed to load');
      }
    }, interval);
  }
};

// function deleteCookie(name) {
//   document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
// }

// // Function to clear the discount code cookie
// function clearDiscountCodeCookie() {
//   deleteCookie('cart');
//   console.log('Discount code cookie cleared.');
// }

// // Run clearDiscountCodeCookie only once per browser
// if (!localStorage.getItem('discountCookieCleared')) {
//   clearDiscountCodeCookie();
//   localStorage.setItem('discountCookieCleared', 'true');
// }

// cross sell product card

class CrossSellProductCard extends HTMLElement {
  constructor() {
    super();
    this.quickBuyId = this.getAttribute('quick-buy-id');
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    const checkbox = this.querySelector('.cross-sell-product-card__checkbox');
    const addButton = this.querySelector('.cross-sell-product-card__add-button');
    const viewButton = this.querySelector('.cross-sell-product-card__view-button');
    const mediaButton = this.querySelector('.cross-sell-product-card__media--quick-view');

    // Handle checkbox change for single variant products
    if (checkbox) {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          const variantId = e.target.getAttribute('data-variant-id');
          this.addToCart(variantId);
        }
      });
    }

    // Handle media button click for multi-variant products (quick view)
    if (mediaButton) {
      mediaButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openQuickBuy();
      });
    }

    // Handle add button click for multi-variant products
    if (addButton) {
      addButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.openQuickBuy();
      });
    }

    // Handle view button click
    if (viewButton) {
      viewButton.addEventListener('click', () => {
        this.openQuickBuy();
      });
    }
  }

  openQuickBuy() {
    const quickBuyModal = this.querySelector('.quick-buy-modal') || document.getElementById(this.quickBuyId);
    if (quickBuyModal && quickBuyModal.show) {
      quickBuyModal.show();
    }
  }

  async addToCart(variantId) {
    // Disable checkbox during request
    const checkbox = this.querySelector('.cross-sell-product-card__checkbox');
    if (checkbox) {
      checkbox.disabled = true;
    }

    try {
      // Prepare sections for cart update (following existing pattern)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      
      document.body.classList.add('loading-spinner');
      if (typeof window.showCustomLoadingOverlay === 'function') {
        window.showCustomLoadingOverlay();
      }

      // Add to cart using the same format as existing system
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }],
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const responseJson = await response.json();

      if (response.ok) {
        // Get updated cart content
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        // Dispatch variant:add event (following existing pattern)
        document.documentElement.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent,
            },
          })
        );

        // Dispatch cart:change event (following existing pattern)
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );

        // If inside pair-with dropdown, notify to close it
        const pairWithDropdown = this.closest('product-pair-with-dropdown');
        if (pairWithDropdown) {
          pairWithDropdown.dispatchEvent(new CustomEvent('pair-with:product-added', { bubbles: true }));
        }

        // Don't remove the card on PDP pair-with section; keep it visible for re-add
        const isPdpPairWith = this.closest('product-pair-with-dropdown') || this.closest('product-list-carousel-container');
        if (!isPdpPairWith) {
          this.style.animation = 'fadeOut 0.3s ease-out forwards';
          setTimeout(() => {
            this.remove();
          }, 300);
        } else {
          // Re-enable checkbox so user can add again if they remove from cart
          if (checkbox) {
            checkbox.disabled = false;
            checkbox.checked = false;
          }
        }

      } else {
        throw new Error(responseJson.description || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Re-enable checkbox and reset state
      if (checkbox) {
        checkbox.disabled = false;
        checkbox.checked = false;
      }
      
      // Show error feedback
      alert(error.message || 'Failed to add product to cart. Please try again.');
    }
    finally {
      document.body.classList.remove('loading-spinner');
      if (typeof window.hideCustomLoadingOverlay === 'function') {
        window.hideCustomLoadingOverlay();
      }
    }
  }
}

// Define the custom element
customElements.define('cross-sell-product-card', CrossSellProductCard);

// =====================
// Cart drawer freebie UI (display only — products are applied at checkout)
// =====================

let __isProcessingFreebies = false;

function getFreebieConfig() {
  const settings = window.themeVariables?.settings;
  const config = settings?.freebiesConfig;
  if (!config || typeof config.enabled === 'undefined') return null;

  const items = Array.isArray(config.items)
    ? config.items
        .filter((it) => it && typeof it.threshold === 'number' && it.threshold > 0 && it.handle)
        .map((it) => ({
          threshold: it.threshold,
          handle: String(it.handle).trim(),
          title: it.title || '',
          price: it.price || 0,
          compareAtPrice: it.compareAtPrice || it.price || 0,
        }))
    : [];

  return {
    enabled: !!config.enabled,
    freeLabel: config.freeLabel || 'FREE',
    lockedLabel: config.lockedLabel || 'Locked',
    unlockedLabel: config.unlockedLabel || 'Unlocked',
    lockedMessage: config.lockedMessage || 'Add ₹[amount] more to unlock',
    items,
  };
}

function isFreebieLineItem(item) {
  return item?.properties?._is_freebie === 'true';
}

function setFreebieStatusIcon(item, isUnlocked) {
  const badge = item.querySelector('.cart-freebie-line-item__status-badge');
  if (!badge) return;

  badge.innerHTML = isUnlocked
    ? '<svg aria-hidden="true" focusable="false" fill="none" width="11" viewBox="0 0 18 24"><path clip-rule="evenodd" d="M.75 11.25a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5v-10.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.75 9.75V6a5.25 5.25 0 1 1 10.5 0v3.75M9 15v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
    : '<svg aria-hidden="true" focusable="false" fill="none" width="11" viewBox="0 0 18 24"><path clip-rule="evenodd" d="M.75 11.25a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5v-10.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.75 9.75V6a5.25 5.25 0 0 1 10.5 0v3.75M9 15v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
}

function updateFreebieLineItemsUI(cartData) {
  const cfg = getFreebieConfig();
  const container = document.querySelector('.cart-freebie-line-items');

  if (!cfg?.enabled || !container) return;

  const subtotal = Math.round((cartData?.items_subtotal_price || 0) / 100);
  const itemCount = cartData?.item_count || 0;

  container.dataset.cartSubtotal = subtotal;
  container.hidden = itemCount === 0;

  if (itemCount === 0) return;

  container.querySelectorAll('.cart-freebie-line-item').forEach((item) => {
    const threshold = parseInt(item.dataset.threshold, 10) || 0;
    const isUnlocked = subtotal >= threshold;

    item.hidden = false;
    item.dataset.unlocked = isUnlocked;
    item.classList.toggle('cart-freebie-line-item--unlocked', isUnlocked);
    item.classList.toggle('cart-freebie-line-item--locked', !isUnlocked);
    setFreebieStatusIcon(item, isUnlocked);

    const badge = item.querySelector('.cart-freebie-line-item__badge');
    if (badge) {
      badge.textContent = isUnlocked ? cfg.unlockedLabel : cfg.lockedLabel;
    }

    const unlockText = item.querySelector('.cart-freebie-line-item__unlock-text');
    if (unlockText) {
      const remaining = Math.max(threshold - subtotal, 0);
      unlockText.textContent = cfg.lockedMessage.replace('[amount]', remaining);
      unlockText.hidden = isUnlocked;
    }

    const lockedPrice = item.querySelector('.cart-freebie-line-item__locked-price');
    const unlockedPrices = item.querySelector('.cart-freebie-line-item__unlocked-prices');
    const checkoutMessage = item.querySelector('.cart-freebie-line-item__checkout-message');
    if (lockedPrice) lockedPrice.hidden = isUnlocked;
    if (unlockedPrices) unlockedPrices.hidden = !isUnlocked;
    if (checkoutMessage) checkoutMessage.hidden = !isUnlocked;
  });
}

async function removeLegacyFreebieLineItems(itemsToRemove) {
  if (!itemsToRemove || itemsToRemove.length === 0) return null;

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );

  const updates = {};
  itemsToRemove.forEach((item) => {
    updates[item.key] = 0;
  });

  const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      updates,
      sections: sectionsToBundle.join(','),
      sections_url: window.location.pathname,
    }),
  });

  const updatedCartContent = await response.json();
  if (!response.ok) throw new Error('Failed to remove legacy freebie line items');

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'item:remove', cart: updatedCartContent },
    })
  );

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && typeof cart.renderContents === 'function') {
    cart.renderContents(updatedCartContent);
  }

  return updatedCartContent;
}

async function processFreebies(cartData) {
  const cfg = getFreebieConfig();
  if (!cfg?.enabled) return;
  if (__isProcessingFreebies) return;

  const legacyFreebies = (cartData.items || []).filter((it) => isFreebieLineItem(it));
  if (legacyFreebies.length === 0) return;

  try {
    __isProcessingFreebies = true;
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    await removeLegacyFreebieLineItems(legacyFreebies);
  } catch (e) {
    console.warn('Legacy freebie cleanup error:', e);
  } finally {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    __isProcessingFreebies = false;
  }
}

async function syncFreebieLineItemsFromCart() {
  try {
    const cartData = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    updateFreebieLineItemsUI(cartData);
  } catch (e) {
    console.warn('Freebie UI sync error:', e);
  }
}

document.addEventListener('cart-drawer:refreshed', syncFreebieLineItemsFromCart);

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.cart-freebie-line-items')) {
    syncFreebieLineItemsFromCart();
  }
});

// Product Card Swatch Handler - Updates product card DOM dynamically
class ProductCardSwatchHandler {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation to handle clicks on product card swatches
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-product-card-swatch]');
      if (!swatch) return;

      event.preventDefault();
      this.updateProductCard(swatch);
    });
  }

  updateProductCard(swatch) {
    const productCard = swatch.closest('product-card');
    if (!productCard) return;

    // Get all product data from data attributes
    const productData = {
      id: swatch.dataset.productId,
      handle: swatch.dataset.productHandle,
      url: swatch.dataset.productUrl,
      title: swatch.dataset.productTitle,
      type: swatch.dataset.productType,
      price: parseInt(swatch.dataset.productPrice),
      compareAtPrice: parseInt(swatch.dataset.productCompareAtPrice) || 0,
      priceFormatted: swatch.dataset.productPriceFormatted,
      compareAtPriceFormatted: swatch.dataset.productCompareAtPriceFormatted,
      imageUrl: swatch.dataset.productImageUrl,
      secondaryImageUrl: swatch.dataset.productSecondaryImageUrl || '',
      variantId: swatch.dataset.productVariantId,
      rating: swatch.dataset.productRating || '',
      reviewsCount: parseInt(swatch.dataset.productReviewsCount) || 0,
      sizes: swatch.dataset.productSizes || '',
      hasCombo: swatch.dataset.productHasCombo === 'true',
      available: swatch.dataset.productAvailable === 'true',
      inventoryQuantity: parseInt(swatch.dataset.productInventoryQuantity) || 0,
      hasLowStockTag: swatch.dataset.productHasLowStockTag === 'true'
    };

    // Show loading state with minimum display time
    const startTime = Date.now();
    const minLoaderTime = 1000; // 1 second minimum
    
    productCard.classList.add('updating');

    try {
      // Update product card handle attribute
      productCard.setAttribute('handle', productData.handle);

      // Update badges (sold-out badge based on availability)
      const badgeList = productCard.querySelector('.badge-list');
      if (badgeList) {
        const soldOutBadge = badgeList.querySelector('.badge--sold-out, sold-out-badge');
        if (soldOutBadge) {
          if (!productData.available) {
            soldOutBadge.removeAttribute('hidden');
            soldOutBadge.style.display = '';
          } else {
            soldOutBadge.setAttribute('hidden', '');
            soldOutBadge.style.display = 'none';
          }
        }
      }

      // Update product title
      const titleLink = productCard.querySelector('.product-title');
      if (titleLink) {
        titleLink.textContent = productData.title;
        titleLink.href = productData.url;
      }

      // Update product type
      const typeContainer = productCard.querySelector('.product-type-card-container');
      if (typeContainer) {
        const typeCard = typeContainer.querySelector('.product-type-card:not(.product-type-card-combo)');
        if (typeCard) {
          typeCard.textContent = productData.type;
        }

        // Update combo tag
        const comboCard = typeContainer.querySelector('.product-type-card-combo');
        if (productData.hasCombo) {
          if (!comboCard) {
            const newComboCard = document.createElement('div');
            newComboCard.className = 'product-type-card product-type-card-combo';
            newComboCard.textContent = 'Make Your Combo';
            typeContainer.appendChild(newComboCard);
          }
        } else if (comboCard) {
          comboCard.remove();
        }
      }

      // Update product images
      const primaryImage = productCard.querySelector('.product-card__image--primary');
      const secondaryImage = productCard.querySelector('.product-card__image--secondary');
      const mediaLink = productCard.querySelector('.product-card__media');

      if (primaryImage && productData.imageUrl) {
        primaryImage.src = productData.imageUrl;
        primaryImage.srcset = '';
        // Update srcset for responsive images
        const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
        const srcset = widths.map(w => {
          const url = productData.imageUrl.replace(/width=\d+/, `width=${w}`);
          return `${url} ${w}w`;
        }).join(', ');
        primaryImage.srcset = srcset;
        primaryImage.loading = 'lazy';
      }

      if (secondaryImage && productData.secondaryImageUrl) {
        secondaryImage.src = productData.secondaryImageUrl;
        secondaryImage.srcset = '';
        const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
        const srcset = widths.map(w => {
          const url = productData.secondaryImageUrl.replace(/width=\d+/, `width=${w}`);
          return `${url} ${w}w`;
        }).join(', ');
        secondaryImage.srcset = srcset;
        secondaryImage.style.display = '';
      } else if (secondaryImage && !productData.secondaryImageUrl) {
        secondaryImage.style.display = 'none';
      }

      if (mediaLink) {
        mediaLink.href = productData.url;
      }

      // Update price
      const priceContainer = productCard.querySelector('.product-card__price-container');
      if (priceContainer) {
        const priceList = priceContainer.querySelector('price-list');
        if (priceList) {
          // Update sale price
          const salePrice = priceList.querySelector('sale-price');
          if (salePrice) {
            salePrice.textContent = productData.priceFormatted;
          }

          // Update compare at price
          const comparePrice = priceList.querySelector('compare-at-price');
          if (productData.compareAtPrice > productData.price) {
            if (comparePrice) {
              comparePrice.textContent = productData.compareAtPriceFormatted;
              comparePrice.style.display = '';
            } else {
              // Create compare at price element if it doesn't exist
              const newComparePrice = document.createElement('compare-at-price');
              newComparePrice.className = 'text-subdued line-through';
              newComparePrice.textContent = productData.compareAtPriceFormatted;
              priceList.insertBefore(newComparePrice, salePrice);
            }
          } else if (comparePrice) {
            comparePrice.style.display = 'none';
          }
        }
        
        // Update inventory display
        const inventoryElement = priceContainer.querySelector('.product-card__inventory');
        if (productData.hasLowStockTag && productData.available && productData.inventoryQuantity > 0 && productData.inventoryQuantity <= 10) {
          if (inventoryElement) {
            inventoryElement.textContent = `Only ${productData.inventoryQuantity} left`;
            inventoryElement.style.display = '';
          } else {
            // Create inventory element if it doesn't exist
            const newInventoryElement = document.createElement('p');
            newInventoryElement.className = 'product-card__inventory';
            newInventoryElement.textContent = `Only ${productData.inventoryQuantity} left`;
            priceContainer.appendChild(newInventoryElement);
          }
        } else if (inventoryElement) {
          inventoryElement.style.display = 'none';
        }
      }

      // Update size display
      const sizeDisplay = productCard.querySelector('.product-card__info p[style*="font-size: 10px"]');
      if (sizeDisplay && productData.sizes) {
        const sizeArray = productData.sizes.split('|');
        sizeDisplay.textContent = sizeArray.join(' | ');
      } else if (sizeDisplay && !productData.sizes) {
        sizeDisplay.textContent = '';
      }

      // Update rating
      const ratingContainer = productCard.querySelector('.rating-product-card');
      if (productData.reviewsCount > 0 && productData.rating) {
        if (ratingContainer) {
          const roundRating = ratingContainer.querySelector('round-rating');
          const reviewsCount = ratingContainer.querySelector('div');
          if (roundRating) roundRating.textContent = productData.rating;
          if (reviewsCount) reviewsCount.textContent = `(${productData.reviewsCount})`;
          ratingContainer.style.display = '';
        }
      } else if (ratingContainer) {
        ratingContainer.style.display = 'none';
      }

      // Update wishlist button - recreate it completely and manually bind Swym functionality
      const wishlistContainer = productCard.querySelector('.wishlist-icon-product-card');
      const oldWishlistButton = productCard.querySelector('.swym-button');
      if (wishlistContainer && oldWishlistButton) {
        // Remove old button completely
        oldWishlistButton.remove();
        
        // Create a completely new button element
        const newWishlistButton = document.createElement('button');
        newWishlistButton.setAttribute('aria-label', `Add ${productData.title} to Wishlist`);
        newWishlistButton.setAttribute('data-with-epi', 'true');
        newWishlistButton.setAttribute('data-swaction', 'addToWishlist');
        newWishlistButton.setAttribute('data-product-id', productData.id);
        newWishlistButton.setAttribute('data-variant-id', productData.variantId);
        
        // Ensure we use the full URL (productData.url should already be full URL from Liquid)
        // If it's relative, construct the full URL
        let productUrl = productData.url;
        if (productUrl && !productUrl.startsWith('http')) {
          // If it's a relative URL, make it absolute
          productUrl = `${window.location.origin}${productUrl.startsWith('/') ? '' : '/'}${productUrl}`;
        }
        newWishlistButton.setAttribute('data-product-url', productUrl);
        
        newWishlistButton.className = `swym-button swym-add-to-wishlist-view-product product_${productData.id}`;
        
        // Don't manually bind handlers - let Swym handle it
        // The button will be initialized via the swym:collections-loaded event
        
        // Append the new button
        wishlistContainer.appendChild(newWishlistButton);
        
        // Also try to initialize via Swym's normal method (but don't rely on it)
        // Swym will be reinitialized via the swym:collections-loaded event dispatched in the finally block
      }

      // Update quick buy modal
      const quickBuyModal = productCard.querySelector('quick-buy-modal');
      if (quickBuyModal) {
        quickBuyModal.setAttribute('handle', `${productData.handle}?variant=${productData.variantId}`);
        const quickBuyId = quickBuyModal.id;
        const quickBuyButton = productCard.querySelector(`[aria-controls="${quickBuyId}"]`);
        if (quickBuyButton && !productData.available) {
          quickBuyButton.style.display = 'none';
        } else if (quickBuyButton) {
          quickBuyButton.style.display = '';
        }
      }

      // Update active swatch state
      const allSwatches = productCard.querySelectorAll('[data-product-card-swatch]');
      allSwatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      // Dispatch custom event for other components that might need to react
      productCard.dispatchEvent(new CustomEvent('product-card:updated', {
        bubbles: true,
        detail: { productData }
      }));

    } catch (error) {
      console.error('Error updating product card:', error);
    } finally {
      // Ensure loader shows for at least 1 second for better UX
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minLoaderTime - elapsedTime);
      
      setTimeout(() => {
        productCard.classList.remove('updating');
        
        // Dispatch Swym event to reinitialize wishlist buttons after product card update
        // This ensures Swym properly updates the wishlist button state (filled/unfilled icon)
        // Use a longer delay to ensure button recreation is complete and DOM is stable
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
        }, 500);
      }, remainingTime);
    }
  }
}

// Initialize the handler
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardSwatchHandler();
    updateSwatchSizes();
  });
} else {
  new ProductCardSwatchHandler();
  updateSwatchSizes();
}

// Function to dynamically update swatch sizes based on card width
function updateSwatchSizes() {
  const updateSwatches = () => {
    const swatchContainers = document.querySelectorAll('.product-card__similar-swatches');
    
    swatchContainers.forEach(container => {
      const hStack = container.querySelector('.h-stack');
      if (!hStack) return;
      
      const containerWidth = container.offsetWidth;
      // gap-1 = 0.25rem = 4px (assuming 16px base)
      const gapSizePx = 4;
      const numSwatches = hStack.querySelectorAll('.product-card__similar-swatch').length || 6;
      const numGaps = Math.max(0, numSwatches - 1);
      const totalGapSpace = gapSizePx * numGaps;
      
      // Calculate swatch width: (container width - total gap space) / number of swatches
      const swatchWidth = (containerWidth - totalGapSpace) / numSwatches;
      
      // Set CSS custom property for dynamic sizing
      container.style.setProperty('--swatch-calculated-size', `${swatchWidth}px`);
    });
  };

  // Update on load
  updateSwatches();

  // Update on resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSwatches, 100);
  });

  // Update when new swatches are added (using MutationObserver)
  const observer = new MutationObserver(() => {
    updateSwatches();
  });

  document.querySelectorAll('.product-card__similar-swatches').forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
}


// =====================
// Testimonial Card Click Handler
// =====================

(function() {
  // Handle card clicks for testimonials
  function initTestimonialCardClickHandler() {
    const cards = document.querySelectorAll('.testimonial-card[data-card-clickable="true"]');
    
    cards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        // Don't trigger card click if clicking on:
        // 1. The read more/less toggle
        // 2. The checkbox
        // 3. The image (it already has its own click handler)
        if (
          e.target.closest('.testimonial-summary-toggle') ||
          e.target.closest('.testimonial-summary-checkbox') ||
          e.target.closest('.testimonial-card__image-button') ||
          e.target.closest('.testimonial-card__image-link')
        ) {
          return;
        }
        
        // Handle quick view
        const quickBuyId = card.getAttribute('data-quick-buy-id');
        if (quickBuyId) {
          const quickBuyButton = card.querySelector('.quick-buy-button');
          if (quickBuyButton) {
            quickBuyButton.click();
          }
        }
        
        // Handle product link
        const productUrl = card.getAttribute('data-product-url');
        if (productUrl) {
          window.location.href = productUrl;
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialCardClickHandler);
  } else {
    initTestimonialCardClickHandler();
  }
})();

// =====================
// Page View Grid Handler
// =====================
// 
(() => {
  // Use a document-level delegate so the handler survives #main swaps
  if (window.__pageViewGridInit) return;
  window.__pageViewGridInit = true;

  function startLoading() {
    document.body.classList.add('loading-spinner');
    if (typeof window.showCustomLoadingOverlay === 'function') {
      window.showCustomLoadingOverlay();
    }
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
  }

  function stopLoading() {
    document.body.classList.remove('loading-spinner');
    if (typeof window.hideCustomLoadingOverlay === 'function') {
      window.hideCustomLoadingOverlay();
    }
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
  }

  let isNavigating = false;

  async function navigate(fetchUrl, pageTitle, shouldPushState) {
    const main = document.getElementById('main');
    if (!main) return;

    if (isNavigating) return;
    isNavigating = true;

    startLoading();

    try {
      const response = await fetch(fetchUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('fetch failed');

      const html = await response.text();
      const tempDoc = new DOMParser().parseFromString(html, 'text/html');
      const nextMain = tempDoc.getElementById('main');

      if (!nextMain) throw new Error('no #main in response');

      // Don't inject footer - it's already on page (moved by fastload) and would duplicate
      const footerInNext = nextMain.querySelector('footer');
      if (footerInNext) footerInNext.remove();

      main.replaceWith(nextMain);
      document.title = tempDoc.title || document.title;

      setActiveBlock(fetchUrl);

      if (shouldPushState) {
        // Keep current base URL, only append page-view param
        const displayUrl = new URL(window.location.href);
        displayUrl.searchParams.set('page-view', pageTitle);
        history.pushState({ pageView: true, fetchUrl, pageTitle }, '', displayUrl.toString());
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.warn('[page-view-grid] navigate error:', err);
    } finally {
      stopLoading();
      isNavigating = false;
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }
  }

  function setActiveBlock(fetchUrl) {
    document.querySelectorAll('[data-page-view-section] [data-page-fetch-url]').forEach((el) => {
      el.classList.toggle('is-active', el.getAttribute('data-page-fetch-url') === fetchUrl);
    });
  }

  function normalizeTitle(value) {
    return (value || '').trim().toLowerCase();
  }

  function initFromPageViewParam() {
    const params = new URLSearchParams(window.location.search);
    const pageView = params.get('page-view');
    const blocks = document.querySelectorAll('[data-page-view-section] [data-page-fetch-url][data-page-title]');
    if (!blocks.length) return;

    if (!pageView) return;

    const normalizedParam = normalizeTitle(pageView);
    const matchingBlock = Array.from(blocks).find((el) => {
      return normalizeTitle(el.getAttribute('data-page-title')) === normalizedParam;
    });

    if (!matchingBlock) return;

    const fetchUrl = matchingBlock.getAttribute('data-page-fetch-url');
    const pageTitle = matchingBlock.getAttribute('data-page-title');
    if (!fetchUrl) return;

    history.replaceState({ pageView: true, fetchUrl, pageTitle }, '', window.location.href);
    setActiveBlock(fetchUrl);
    navigate(fetchUrl, pageTitle, false);
  }

  document.addEventListener('click', function(event) {
    // Only handle real user clicks, not synthetic/programmatic events
    if (!event.isTrusted) return;

    const trigger = event.target.closest('[data-page-fetch-url]');
    if (!trigger) return;

    // Only handle clicks inside a page-view-grid section
    if (!trigger.closest('[data-page-view-section]')) return;

    event.preventDefault();

    const fetchUrl = trigger.getAttribute('data-page-fetch-url');
    const pageTitle = trigger.getAttribute('data-page-title');
    navigate(fetchUrl, pageTitle, true);
  });

  window.addEventListener('popstate', function(event) {
    if (event.state && event.state.pageView && event.state.fetchUrl) {
      setActiveBlock(event.state.fetchUrl);
      navigate(event.state.fetchUrl, event.state.pageTitle, false);
    }
  });

  initFromPageViewParam();
})();

// PDP: show the selected variant's absolute discount (not "Upto") when options change
document.addEventListener('variant:change', (event) => {
  const formId = event.detail?.formId;
  const variant = event.detail?.variant;
  if (!formId || !variant) return;

  const picker = document.querySelector(`variant-picker[form-id="${formId}"][data-discount-format="variant"]`);
  if (!picker) return;

  const scope = picker.closest('product-rerender');
  if (!scope) return;

  scope.querySelectorAll('on-sale-badge.badge--on-sale').forEach((badge) => {
    const compareAt = variant.compare_at_price;
    const price = variant.price;
    const discountMode = badge.getAttribute('discount-mode') || 'percentage';

    if (compareAt > price && variant.available !== false) {
      let savings;

      if (discountMode === 'percentage') {
        savings = `${Math.round((compareAt - price) * 100 / compareAt)}%`;
      } else if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        savings = Shopify.formatMoney(compareAt - price);
      } else {
        return;
      }

      badge.textContent = `${savings} OFF`;
      badge.hidden = false;
      badge.closest('badge-list')?.removeAttribute('hidden');
    } else {
      badge.hidden = true;
    }
  });
});